/**
 * Constants for presence periods
 */

export const FULLDAY_PERIOD = 'fullday';
export const MORNING_PERIOD = 'morning';
export const AFTERNOON_PERIOD = 'afternoon';
